import { formatTimeString } from '~libs/dayjs';

import { faEdit } from '~components/icon';
import { buildColumn, EditableColumnConfig } from '~components/table-view';

const commonColumnsList: EditableColumnConfig[] = [
  {
    id: 'reference_number',
    header: 'Reference Number',
    type: 'link',
    props: {
      meta: {
        link: ({ id }: any) => `/appointments/${id}`,
        hoverIcon: faEdit,
        dataCy: (id: number) => `appointments-table-row-${id}`,
      },
    },
  },
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
  },
  {
    id: 'date',
    header: 'Date',
    type: 'date',
  },
  {
    id: 'start_time',
    header: 'Start Time',
    type: 'text',
    accessorFn: ({ start_time }) => formatTimeString(start_time),
  },
  {
    id: 'end_time',
    header: 'End Time',
    type: 'text',
    accessorFn: ({ end_time }) => formatTimeString(end_time),
  },
  {
    id: 'status.name',
    header: 'Status',
    type: 'text',
  },
  {
    id: 'company.name',
    header: 'Company',
    type: 'text',
  },
];

const allColumnsList: EditableColumnConfig[] = [
  ...commonColumnsList,
  {
    id: 'user.full_name',
    header: 'Care Worker',
    type: 'text',
  },
  {
    id: 'client.referrer_name',
    header: 'Referrer',
    type: 'text',
  },
  {
    id: 'package_fixed.name',
    header: 'Package',
    type: 'text',
  },
  {
    id: 'service_type.name',
    header: 'Service Type',
    type: 'text',
    accessorFn: ({ service_type }) =>
      service_type !== undefined ? `${service_type.name}${service_type.deleted ? ' - DELETED' : ''}` : '',
  },
];

export const commonColumns = commonColumnsList.map(buildColumn);
export const allColumns = allColumnsList.map(buildColumn);

export default commonColumns;
